import { render } from "./BackupTriggerEditDialog.vue?vue&type=template&id=68e57804"
import script from "./BackupTriggerEditDialog.vue?vue&type=script&lang=js"
export * from "./BackupTriggerEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__